<script setup lang="ts">

import { reactive } from "vue";
import { BucksPanel, LinkedCards, LinkedBankAccount, PendingTransactions, ProfileHeader } from "../Components";
import { CarbucksPromotion } from "../Promotion";
import { useViewModelInstance } from "../";
import { useBackButton } from "@app/Components/Utilities";

const viewModel = await useViewModelInstance();
let model = reactive( viewModel.profile );        

useBackButton( true );

</script>

<template>

    <div class="w-full h-full overflow-y-auto pb-12
                flex flex-col gap-4 lg:gap-6">

        <div v-if="viewModel.isLoaded && model.hasLinkedCards">

            <div class="bg-gradient-to-b dark:from-gray-900 dark:to-gray-850">
                <ProfileHeader v-model="model" :is-marketplace="false" />
                <BucksPanel v-model="model" />
            </div>

            <PendingTransactions v-model="model" />
            <LinkedCards v-model="model" />
            <LinkedBankAccount v-model="model" />

        </div> 

        <CarbucksPromotion v-else v-model="model" />

    </div>

</template>
